import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';

@Component({
  selector: 'app-banner-segofinance',
  templateUrl: './banner-segofinance.component.html',
  styleUrls: ['./banner-segofinance.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    ReactiveFormsModule,
    BtnLinkComponent
  ]
})

export class BannerSegofinanceComponent implements OnInit {
  isLogged: boolean;
  portadaForm: FormGroup;

  constructor(private _usuarioService: UsuarioService, private _router: Router, private _formBuilder: FormBuilder){}

  ngOnInit(): void {
    this.getSession();
    this.buildForm();
  }

  private getSession(): void {
    this.isLogged = this._usuarioService.getSession() ? true : false;
  }

  private buildForm(): void
  {
    this.portadaForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }
}


